<template>
  <div class="boxshell">
    <van-loading size="48px" text-size="24px">加载中...</van-loading>
  </div>
</template>

<script>
export default {
  name: 'accessFailed',
  data() {
    return {
      msg: this.$route.query.msg
    };
  },
  created(){
    let query = window.location.href.split('?')[1]
    // console.log(`/backloansuper/loan/supermarket/gotourl?${query}&j=${this.IsMiniProgramEnv()}`)
    window.location.href = `/backloansuper/loan/supermarket/gotourl?${query}&j=${this.IsMiniProgramEnv()}`
  },
  methods:{
    // 判断是否是小程序环境
    IsMiniProgramEnv() {
      // 通过navigator.userAgent 判断
      var bl = navigator.userAgent && navigator.userAgent.indexOf('miniProgram') > -1
      return bl?'1':'0'
    },
  }
};
</script>
<style scoped>
.boxshell {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
